import { useEffect, useState } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { copy } from "@/i18n";
import { HudNav } from "@/components/HudNav";
import { KineticHero } from "@/components/KineticHero";
import { TacticalMarquee } from "@/components/TacticalMarquee";
import { StealthTech } from "@/sections/StealthTech";
import { ProductLines } from "@/sections/ProductLines";
import { FiberAlarm } from "@/sections/FiberAlarm";
import { Verification } from "@/sections/Verification";
import { Lifecycle } from "@/sections/Lifecycle";
import { Contact } from "@/sections/Contact";
import { LineDetail } from "@/pages/LineDetail";
import { Gallery } from "@/pages/Gallery";
import { SiteFooter } from "@/components/SiteFooter";

const Landing = ({ t, lang, setLang }) => (
  <div id="top" className="bg-[#050505] min-h-screen text-white antialiased">
    <HudNav t={t.nav} lang={lang} setLang={setLang} pdfLabel={t.pdf_btn} pdfBusy={t.pdf_busy} galleryLabel={t.galleryPage.title} />
    <main>
      <KineticHero t={t.hero} />
      <TacticalMarquee text={t.marquee} />
      <StealthTech t={t.stealth} />
      <ProductLines t={t.lines} label={t.lines_details_label} />
      <FiberAlarm t={t.alarm} />
      <Verification t={t.verification} chart={t.chart} />
      <TacticalMarquee text={t.marquee} />
      <Lifecycle t={t.lifecycle} />
      <Contact t={t.contact} />
    </main>
    <SiteFooter t={t} />
  </div>
);

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("ss-lang") || "it");
  const t = copy[lang];

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.4, smoothWheel: true });
    const raf = (time) => { lenis.raf(time); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("ss-lang", lang);
  }, [lang]);

  return (
    <BrowserRouter>
      <div className="noise-overlay" aria-hidden="true" />
      <Routes>
        <Route path="/" element={<Landing t={t} lang={lang} setLang={setLang} />} />
        <Route path="/linea/:id" element={<LineDetail t={t} lang={lang} setLang={setLang} />} />
        <Route path="/galleria" element={<Gallery t={t} />} />
      </Routes>
      <Toaster theme="dark" position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
